import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../app/store';

interface BenchmarkState {
  currentDate?: string;
  benchmarkId?: string;
  benchmarkDate?: string;
}

const initialState: BenchmarkState = {};

export const benchmarkSlice = createSlice({
  name: 'benchmark',
  initialState,
  reducers: {
    updateCurrentDate(state, action: PayloadAction<string>) {
      state.currentDate = action.payload;
    },
    updateBenchmarkId(state, action: PayloadAction<string>) {
      state.benchmarkId = action.payload;
    },
    updateBenchmarkDate(state, action: PayloadAction<string>) {
      state.benchmarkDate = action.payload;
    },
    deleteBenchmark(state) {
      state.benchmarkId = undefined;
      state.benchmarkDate = undefined;
    },
  },
});

export const selectBenchmark = (state: RootState) => state.benchmark;

export const benchmarkReducer = benchmarkSlice.reducer;
export const { updateCurrentDate, updateBenchmarkId, updateBenchmarkDate, deleteBenchmark } =
  benchmarkSlice.actions;
